import React from 'react';
import { observer } from 'mobx-react-lite';
import { userStore, generalStore } from '../../store';
import { FiX, FiCheck } from 'react-icons/fi';

interface FilterModalProps {
  visible: boolean;
  onClose: () => void;
}

const FilterModal: React.FC<FilterModalProps> = observer(({ visible, onClose }) => {
  if (!visible) return null;

  const handleApply = () => {
    const selectedIds = userStore.bookCat
      .filter((cat) => cat.selected)
      .map((cat) => cat._id);
    generalStore.setSelectedFilter(selectedIds);
    onClose();
  };

  const handleClear = () => {
    userStore.clearCategorySelections();
    generalStore.clearFilters();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-40">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl max-h-[70vh] flex flex-col safe-area-bottom animate-slide-up">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900">Filter by Category</h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 active:bg-gray-200"
          >
            <FiX className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {userStore.bookCat.map((cat) => (
            <button
              key={cat._id}
              onClick={() => userStore.toggleCategorySelection(cat._id)}
              className={`w-full flex items-center justify-between px-4 py-3 rounded-xl border transition-colors ${
                cat.selected
                  ? 'border-[#39377F] bg-[#39377F]/5'
                  : 'border-gray-200 bg-white'
              }`}
            >
              <span
                className={`text-sm font-medium ${
                  cat.selected ? 'text-[#39377F]' : 'text-gray-700'
                }`}
              >
                {cat.name}
              </span>
              {cat.selected && (
                <div className="w-5 h-5 bg-[#39377F] rounded-full flex items-center justify-center">
                  <FiCheck className="w-3 h-3 text-white" />
                </div>
              )}
            </button>
          ))}
          {userStore.bookCat.length === 0 && (
            <p className="text-center text-gray-400 text-sm py-8">No categories available</p>
          )}
        </div>

        <div className="flex gap-3 p-4 border-t border-gray-100">
          <button
            onClick={handleClear}
            className="flex-1 py-3 border-2 border-gray-200 text-gray-700 rounded-xl font-semibold text-sm active:bg-gray-50 transition-colors"
          >
            Clear All
          </button>
          <button
            onClick={handleApply}
            className="flex-1 py-3 bg-[#39377F] text-white rounded-xl font-semibold text-sm active:opacity-80 transition-opacity"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
});

export default FilterModal;
